export const fontSize = {
  h1: "38px",
  h2: "30px",
  h3: "24px",
  h4: "20px",
  h5: "16px",
  p: "14x",
};
